import { render, staticRenderFns } from "./wizard-bulk-buttons.vue?vue&type=template&id=0ba3fdbc"
import script from "./wizard-bulk-buttons.vue?vue&type=script&lang=js"
export * from "./wizard-bulk-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports